import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';
import { Dropdown } from '@glu/dropdown-react';
import { Input } from '@glu/form-components';
import MobileGridContext from '../logic/MobileGridContext';
import * as actions from '../logic/actions';

const useStyles = createUseStyles(() => ({
  container: {
    display: 'flex'
  },
  marginRight: {
    marginRight: '15px'
  },
  noMarginBottom: {
    marginBottom: '0'
  },
  fullWidth: {
    position: 'relative',
    '& > label': {
      width: '100%',
      // Get the danged dropdown to be above inputs
      '& + div': {
        zIndex: '99'
      }
    }
  }
}));

const numberDropdownOptions = [
  {
    id: 'equals',
    name: 'Equals',
    criteriaDisplay: 'Equals'
  },
  {
    id: 'greaterThan',
    name: 'Is Greater Than',
    criteriaDisplay: 'Greater than'
  },
  {
    id: 'lessThan',
    name: 'Is Less Than',
    criteriaDisplay: 'Less than'
  }
];

const NumberFilter = ({ column }) => {
  const classes = useStyles();
  const gridContext = React.useContext(MobileGridContext);
  const { field, headerName } = column;
  const unAppliedFilterState = gridContext?.unAppliedFilterState || [];
  const filterValues = unAppliedFilterState.filter((filter) => filter.field === field);
  const displayValue = filterValues[0]?.filterData?.filter;
  const selectedDropdownValue = numberDropdownOptions.filter(
    (option) => option.id === filterValues[0]?.filterData?.type
  );
  return (
    <div className={classes.container} style={{ flexDirection: 'column' }}>
      <Dropdown
        filterEnabled={false}
        className={`${classes.fullWidth} ${classes.marginRight} ${classes.noMarginBottom}`}
        options={numberDropdownOptions}
        value={selectedDropdownValue}
        onChange={(_name, value) => {
          actions.updateUnappliedFilters({
            gridContext,
            payload: {
              name: field,
              value: {
                field,
                nameDisplay: headerName,
                criteriaDisplay: value[0].criteriaDisplay,
                id: `${field}-contains-${value[0].criteriaDisplay} ${displayValue}`,
                filterData: {
                  type: value[0].id,
                  filter: displayValue,
                  filterType: 'number'
                }
              }
            }
          });
        }}
      />
      <Input
        type="number"
        name={`${field}-filter`}
        labelText={` `}
        // User must select dropdown type first before entering number
        disabled={!selectedDropdownValue}
        className={`${classes.fullWidth} ${classes.marginRight}`}
        value={displayValue}
        onChange={(e) => {
          const { value } = e.target;
          actions.updateUnappliedFilters({
            gridContext,
            payload: {
              name: field,
              value: {
                field,
                nameDisplay: headerName,
                criteriaDisplay: selectedDropdownValue.criteriaDisplay,
                id: `${field}-contains-${selectedDropdownValue.criteriaDisplay} ${value}`,
                filterData: {
                  type: selectedDropdownValue[0].id,
                  filter: value,
                  filterType: 'number'
                }
              }
            }
          });
        }}
      />
    </div>
  );
};

NumberFilter.propTypes = {
  column: PropTypes.shape({
    field: PropTypes.string,
    headerName: PropTypes.string
  }).isRequired
};

export default NumberFilter;
